import React, { Component } from "react";
import { Button, Card, CardGroup, Modal } from "react-bootstrap";
import { Checkbox } from "@material-ui/core";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import L from "leaflet";
import { MapContainer, TileLayer, LayersControl, GeoJSON } from "react-leaflet";
import hash from "object-hash";
import Axios from "../../redux/axiosHandlerGeo";
import GeoJsonLayer from "./GeoJsonLayer";
import kanchanpur from "../../geojson/kanchanpur.json";
import { infastructure } from "../../variable/global";
// import kanchanpur from "../../geojson/bedkot.json";
import {MdPlace} from 'react-icons/md';
import "leaflet/dist/leaflet.css";
import "../../assets/css/homePageDescription.scss";
import { connect } from "react-redux";

class MunicipalityDescription extends Component {
	constructor(props) {
		super(props);
		this.state = {
			modalShow: false,
			boundData: [],
			wholeGeojson: [],
			location: {
				lat: 27.938571,
				lng: 85.918619,
			},
			zoom: 11,
			checkbox: {},
			wholeGeoJSON: {},
			showGeoJSON: [],
			sectionTitle: "",
		};
	}
	// 	this.getMunicpalId = this.getMunicpalId.bind(this);
	// }

	// isGeoJsonAlreadyFetched = (field) => {
	// 	const { wholeGeoJSON } = this.state;
	// 	return Boolean(wholeGeoJSON[field]);
	// };

	// fetchGeoJSON = (changedData) => {
	// 	const body = {
	// 		industries: "institute/industries",
	// 		cultural_heritage: "institute/cultural_heritage",
	// 		gov_office: "institute/gov_office",
	// 		forest: "institute/forest",
	// 		offices: "institute/offices",
	// 		infrastructure: "institute/infrastructure",
	// 		economic: "institute/economic",
	// 		education: "institute/education",
	// 		security: "institute/security",
	// 		palika_related_office: "institute/palika_related_office",
	// 		public_places: "institute/public_places",
	// 		health: "institute/health",
	// 	};

	// 	return new Promise((resolve, reject) => {
	// 		Axios.get(`/api/geojson/${body[changedData]}`)
	// 			.then((result) => {
	// 				const wholeGeoJSON = this.state.wholeGeoJSON;
	// 				this.setState(
	// 					{
	// 						wholeGeoJSON: {
	// 							...wholeGeoJSON,
	// 							[changedData]: result.data,
	// 						},
	// 					},
	// 					() => resolve()
	// 				);
	// 			})
	// 			.catch((err) => reject());
	// 	});
	// };

	// arrangeAllOption = async () => {
	// 	const { checkbox } = this.state;

	// 	const showGeoJSON = [];
	// 	let dataToCheck = [];

	// 	dataToCheck = dataToCheck.concat(infastructure);
	// 	const data = dataToCheck.map(async (each, i) => {
	// 		if (checkbox[each.value]) {
	// 			if (!this.isGeoJsonAlreadyFetched(each.value))
	// 				await this.fetchGeoJSON(each.value);

	// 			showGeoJSON.push(this.state.wholeGeoJSON[each.value]);
	// 		}
	// 	});
	// 	// wait until all promises resolve
	// 	await Promise.all(data);

	// 	this.setState({ showGeoJSON });
	// };

	// handleChange = (e) => {
	// 	e.persist();
	// 	this.setState(
	// 		({ checkbox }) => ({
	// 			checkbox: {
	// 				...checkbox,
	// 				[e.target.name]: e.target.checked,
	// 			},
	// 		}),
	// 		this.arrangeAllOption
	// 	);
	// };

	// style(feature) {
	// 	let skin = "blue";
	// 	if (feature.properties.FIRST_GaPa === "Bhimdatta") {
	// 		skin = "green";
	// 	}
	// 	return {
	// 		fillColor: skin,
	// 		weight: 1,
	// 		opacity: 1,
	// 		color: "black",
	// 		fillOpacity: 0.3,
	// 	};
	// }

	componentDidMount() {
		const boundData = [
			{
				key: "पुर्व",
				keyEnglish: "East",
				value: "दोलखा जिल्ला",
				valueEnglish: "Dolakha district",
				class: "col-md-12",
			},
			{
				key: "उत्तर",
				keyEnglish: "North",
				value: "चीन",
				valueEnglish: "China",
				class: "col-md-12",
			},
			{
				key: "पश्चिम",
				keyEnglish: "West",
				value: "जुगल गाउँपालिका",
				valueEnglish: "Jugal Rural Municipality",
				class: "col-md-12",
			},
			{
				key: "दक्षिण",
				keyEnglish: "South",
				value: "बाह्रविसे नगरपालिका",
				valueEnglish: "Barhabise Municipality",
				class: "col-md-12",
			},
			{
				key: "क्षेत्रफल",
				keyEnglish: "Area",
				value: "२७८.३१ ( वर्ग कि.मी.)",
				valueEnglish: "278.31 (sq. Km.)",
				class: "col-md-12",
			},
			{
				key: " वडा संख्या",
				keyEnglish: "ward",
				value: "५",
				valueEnglish: "5",
				class: "col-md-12",
			},
			{
				key: "अक्षांश तथा देशान्तर",
				keyEnglish: "latitude and longitude",
				value: "२९°१०′५९″N , ८३°५७′२४″E",
				valueEnglish: "29°10′59″N , 83°57′24″E",
				class: "col-12",
			},
			// {
			// 	key: "मुख्य सहरी क्षेत्र",
			// 	keyEnglish: "Main city area",
			// 	value: "",
			// 	class: "col-12",
			// },
		];
		this.setState({ ...this.state, boundData });
	}
	getMunicipalBounds() {
		let modalClose = () => this.setState({ modalShow: false });
		return (
			<div className="col-lg-5 pb-5 d-flex">
				<Card>
					<Card.Body>
						<div className="d-flex pb-8">
							<SVG
								className="primary-icon"
								src={toAbsoluteUrl("media/hamropalika/svg/map_marker.svg")}
								alt=""
							/>
							<h2 className="font-weight-black pl-3 pt-6 homepage-heading">
								{this.props.selectedLanguage == "nepali"
									? "सिमाना"
									: "Boundaries"}
							</h2>
						</div>
						<div className="row">
							{this.state.boundData.map((data, index) => {
								return (
									<div className={`pb-3 ${data.class}`} key={index}>
										<div className="row">
											<div className="col-4">
												<h5 className="pr-2">
													{this.props.selectedLanguage == "nepali"
														? data.key
														: data.keyEnglish}
													:
												</h5>
											</div>
											<div className="col-8">
												<h5 className="text-primary">
													{this.props.selectedLanguage == "nepali"
														? data.value
														: data.valueEnglish}
												</h5>
											</div>
										</div>
									</div>
								);
							})}
						</div>
						<div className="float-right ">
							<Button
								className="px-10 emergency-button text-danger"
								variant="light-danger"
								size="lg"
								onClick={() => this.setState({ modalShow: true })}
							>
								{" "}
								<i className="icon-emergency"></i> {" "}
								{this.props.selectedLanguage == "nepali"
									? "आपतकालीन सम्पर्क"
									: "Emergency Contact"}
							</Button>
							{/* 
							<EmergencyContactModal
								selectedLanguage={this.props.selectedLanguage}
								show={this.state.modalShow}
								onHide={modalClose}
							/> */}
						</div>
					</Card.Body>
				</Card>
			</div>
		);
	}
	getMunicpalId() {
		return (
			<div className="col-lg-12 pb-5 d-flex ">
				<Card>
					<Card.Body>
						<div className="d-flex pb-8">
							<SVG
								className="primary-icon"
								src={toAbsoluteUrl("media/hamropalika/svg/municipality_id.svg")}
								alt=""
							/>
							<h2 className=" pl-3 pt-6 homepage-heading">
								{this.props.selectedLanguage == "nepali"
									? "गाउँपालिका अबस्थित  नक्शा"
									: "Rural Municipality Location Map"}
							</h2>
						</div>

						<h4 className="col-lg-6 pb-5 d-flex">
							{this.props.selectedLanguage === "nepali"
								? "भोटेकोशी गाउँपालिका नेपालको बागमती प्रदेश, मध्यमाञ्चल विकास" +
								  "क्षेत्र अन्तर्गत सिन्धुपाल्चोक जिल्लामा अवस्थित गाउँपालिका हो ।" +
								  "विसं २०७३ सालमा नेपालको नयाँ प्रादेशिक संरचना कायम गर्दा समावेस" +
								  "भएका साविक गाविसहरू: लिस्तीकोट, तातोपानी, फुल्पिङकट्टी र मार्मिङ" +
								  "गाविस मिलेर भोटेकोशी गाउँपालिका घोषणा गरिएको हो।चिन संङ्ग सिमाना" +
								  "जोडिएर बसेको पहाडको एक नेपालकै मुख्य नाका रहेको तातोपानी भन्सार," +
								  "अग्ला चट्टान सहितको पहाडी भूभाग रहेको नेपालको उत्तरी क्षेत्रमा" +
								  "यस भोटेकोशी गाउँपालिका रहि आएको छ| मुख्य रूपमा नेपाली, तामाङ" +
								  "शेर्पा भाषा तथा बौद्ध धर्मालम्बीहरुको बाहुल्यता सहित विभिन्न" +
								  "नेपाली संस्कृतिको समिश्रण रहेको देखिन्छ| यस गाउँपालिकाको" +
								  "केन्द्र: साविकको फुप्लिङकट्टी गाविस : हाल वडा ४ टोल हिन्दीमा" +
								  "रहेकोछ |"
								: "Bhotekoshi is a Rural Municipality in Sindhupalchowk district in" +
								  "Bagmati Province, of Nepal. The former VDCs: Listikot, Tatopani," +
								  "Fulpingkatti and Marming VDCs have been declared as Bhotekoshi" +
								  "Rural Municipality in 2073 BS when the new provincial structure" +
								  "of Nepal was established. Bhotekoshi is a Municipality in the" +
								  "northern part of Nepal, which is a hilly region with high" +
								  "cliffs, There seems to be a mixture of different Nepali" +
								  "cultures, mainly Nepali, Tamang Sherpa language and Buddhist in" +
								  "majority. Center of this Rural Municipality: Fuplingkatti VDC of" +
								  "Savik: Currently Ward 4 is in Hindi."}
						</h4>

						{/* <div className="d-flex pb-8">
							<SVG
								className="primary-icon"
								src={toAbsoluteUrl("media/hamropalika/svg/map_marker.svg")}
								alt=""
							/>
							<h2 className="font-weight-black pl-3 pt-6">
								{this.props.selectedLanguage == "nepali"
									? "सिमाना"
									: "Boundaries"}
							</h2>
						</div> */}
						<div className="col-lg-5 pb-5 d-flex">
							<div className="row">
								{this.state.boundData.map((data, index) => {
									return (
										<div className={`pb-3 ${data.class}`} key={index}>
											<div className="row">
												<div className="col-4">
													<h5 className="pr-2">
														{this.props.selectedLanguage == "nepali"
															? data.key
															: data.keyEnglish}
														:
													</h5>
												</div>
												<div className="col-8">
													<h5 className="text-primary">
														{this.props.selectedLanguage == "nepali"
															? data.value
															: data.valueEnglish}
													</h5>
												</div>
											</div>
										</div>
									);
								})}
							</div>
						</div>
						{/* <img
							className="w-100"
							src={toAbsoluteUrl("/media/hamropalika/bhotekoshiStatic.png")}
							alt=""
						/> */}
					</Card.Body>
				</Card>
			</div>
		);
	}
	render() {
		return (
			<>
				<Card>
					<Card.Body>
						<Card.Title className="d-md-flex justify-space-between row">
							<div className="d-flex col-md-6">
								<SVG
									className="primary-icon"
									style={{width: '32px'}}
									src={toAbsoluteUrl(
										"media/hamropalika/svg/municipality_id.svg"
									)}
									alt=""
								/>
								<h2 className="font-weight-black pl-3 pt-5 homepage-heading">
									{this.props.selectedLanguage == "nepali"
										? "गाउँपालिका संक्षिप्त परिचय"
										: "Village Municipality Brief introduction"}
								</h2>
							</div>
							<div id="destination">								
								<h2 className="font-weight-black pl-3 pt-5 homepage-heading">
								<MdPlace id="destination-icon" style={{width: '32px'}}/>
								{" "}
									{this.props.selectedLanguage == "nepali"
										? "पर्यटकीय तथा महत्वपूर्ण स्थान"
										: "Tourist and important places"}
								</h2>
							</div>
						</Card.Title>
						<Card.Text>
							<div className="row">
								<div className="col-md-12 d-md-flex ">
									<div className="col-md-6 text-justify" id="intro-para">
										<h4>
											{this.props.selectedLanguage === "nepali"
												? "भोटेकोशी गाउँपालिका नेपालको बागमती प्रदेश, मध्यमाञ्चल विकास" +
												  "क्षेत्र अन्तर्गत सिन्धुपाल्चोक जिल्लामा अवस्थित गाउँपालिका हो ।" +
												  "विसं २०७३ सालमा नेपालको नयाँ प्रादेशिक संरचना कायम गर्दा समावेस" +
												  "भएका साविक गाविसहरू: लिस्तीकोट, तातोपानी, फुल्पिङकट्टी र मार्मिङ" +
												  "गाविस मिलेर भोटेकोशी गाउँपालिका घोषणा गरिएको हो।चिन संङ्ग सिमाना" +
												  "जोडिएर बसेको पहाडको एक नेपालकै मुख्य नाका रहेको तातोपानी भन्सार," +
												  "अग्ला चट्टान सहितको पहाडी भूभाग रहेको नेपालको उत्तरी क्षेत्रमा" +
												  "यस भोटेकोशी गाउँपालिका रहि आएको छ| मुख्य रूपमा नेपाली, तामाङ" +
												  "शेर्पा भाषा तथा बौद्ध धर्मालम्बीहरुको बाहुल्यता सहित विभिन्न" +
												  "नेपाली संस्कृतिको समिश्रण रहेको देखिन्छ| यस गाउँपालिकाको" +
												  "केन्द्र: साविकको फुप्लिङकट्टी गाविस : हाल वडा ४ टोल हिन्दीमा" +
												  "रहेकोछ |"
												: "Bhotekoshi is a Rural Municipality in Sindhupalchowk district in" +
												  "Bagmati Province, of Nepal. The former VDCs: Listikot, Tatopani," +
												  "Fulpingkatti and Marming VDCs have been declared as Bhotekoshi" +
												  "Rural Municipality in 2073 BS when the new provincial structure" +
												  "of Nepal was established. Bhotekoshi is a Municipality in the" +
												  "northern part of Nepal, which is a hilly region with high" +
												  "cliffs, There seems to be a mixture of different Nepali" +
												  "cultures, mainly Nepali, Tamang Sherpa language and Buddhist in" +
												  "majority. Center of this Rural Municipality: Fuplingkatti VDC of" +
												  "Savik: Currently Ward 4 is in Hindi."}
										</h4>
									</div>
									<div className="d-flex pb-8 d-sm-block d-md-none col-md-6 justify-content-start">
										
										<h2 className="font-weight-black pl-3 pt-5 homepage-heading text-left">
											<MdPlace id="destination-icon" style={{width: '32px'}}/>
											{" "}
											{this.props.selectedLanguage == "nepali"
											? "पार्यटकीय तथा महत्वपूर्ण स्थान"
											: "Tourist and important places"}
										</h2>
									</div>
									<div className="col-md-6 overflow-auto">
										<div className="card-content text-justify">
											<div className="card" id="card">
												<img
													className="card-img-top"
													src={toAbsoluteUrl("media/description/tatopani.jpg")}
													alt=""
												/>
												<div className="card-body">
													<h3>
														<b>
															{this.props.selectedLanguage === "nepali"
																? "तातोपानी छहरा"
																: "Hot water face"}
														</b>
													</h3>
													<p className="card-text text-left">
														{this.props.selectedLanguage === "nepali"
															? "प्राकृतिक तातोपानीको मुहान मध्येको एक तातोपानी छहरा  नेपाल र चीनको सिमानामा कोदारीबाट करिब पाँच किलोमिटर दक्षिणमा र नेपालको राजधानी सहर काठमाडौंबाट  करिब ११२ किलोमिटरको दुरीमा अवस्थित छ। यो तातोपानीको प्राकृतिक छहरा  औषधीय शक्ति भएको भनिएको तातो  पानीमा पीडाबाट आराम खोज्ने र स्फूर्तिदायी नुहाउन जाने नेपालीहरूमाझ लोकप्रिय छ।यस ठाउँलाई धार्मिक तथा प्राकृतिक दुवै तवरले एतिहासिक पर्यटकीय स्थलको रुपमा निर्माण गरिएको छ | यहाँ रहेको प्राकृतिक तातो पानीको झरना, देवीको मन्दिर र छेउमा  रहेको भोटेकोशी नदीको प्राकृतिक सौन्दर्यले पर्यटकहरुलाई आनन्दित बनाउँछ साथै आसपासमा रहेका बौद्ध गुम्बाहरु पनि पर्यटकका लागी  धार्मिक स्थलको रुपमा रहेका छन  | यस क्षेत्रपुग्न सडक बाटोको सुविधा तथा पर्यटकहरुका लागी आवास तथा खानाका लागि  होटलहरुको उपलब्दता  रहेको पाइन्छ |   "
															: "One of the natural hot springs is located at a distance of about five kilometers south of Kodari on the Nepal-China border and about 112 kilometers from Kathmandu, the capital city of Nepal. It is popular among Nepalis who seek relief from the pain and take a refreshing bath in the hot water, which is said to have a medicinal power of hot water. The natural hot springs, the temple of the goddess and the nearby Bhotekoshi river"}
													</p>
												</div>
											</div>
											<div className="card" id="card">
												<img
													className="card-img-top"
													src={toAbsoluteUrl(
														"media/description/bhairavkunda.jpg"
													)}
													alt=""
												/>
												<div className="card-body" id="card-body">
													<h3>
														<b>
															{this.props.selectedLanguage === "nepali"
																? "भैरव कुण्ड ताल "
																: "Bhairav Kunda Taal"}
														</b>
													</h3>
													<p className="card-text text-left overflow-hidden">
														{this.props.selectedLanguage === "nepali"
															? "भैरव कुण्ड तालको नाम भगवान शिवको विनाशकारी रूप भैरवको नामबाट राखिएको हो। यो ताल ,बौद्ध,  हिन्दु र झाक्रीहरूका लागि समान रूपमा पवित्र स्थान हो। प्रत्येक वर्ष भाद्रको पूर्णिमाको दिन ठूलो धार्मिक मेला लाग्ने गरेको छ  जसमा भारत र तिब्बतबाट भक्तजनहरू यस पवित्र तालको दर्शन गर्न आउने गरेको पाइएको छ । भैरवकुण्ड पदयात्रा नेपालको दोर्जे लाक्पा हिमाल ६९६६ मिटर, रोल्वालिङ हिमाल पर्वत, जुगल हिमाल, मडिया हिमाल ६२५७ मिटर, फुर्बी घ्याचु हिमाल ६६३७ मिटर र नेपालका अन्य चुचुरा तथा तिब्बत र नेपालको  हिमालहरुको  मनोरम दृश्य  पदयात्राका लागि परिचित छ।"
															: "Bhairav ​​Kunda Lake is named after the destructive form of Lord Shiva, Bhairav. It is an equally sacred place for Buddhists, Buddhists, Hindus and Zacharys. Every year on the full moon day of Bhadra, a big religious fair is held in which devotees from India and Tibet come to visit this sacred lake. Bhairavkund trekking Nepal's Dorje Lakpa Himal 6966 m, Rolling Himal Parbat, Jugal Himal, Madiya Himal 6257 m, Phurbi Ghyachu Himal 6637 m and other peaks of Nepal and the mind of Tibet and Nepal's mountains"}
													</p>
												</div>
											</div>
											<div className="card" id="card">
												<img
													className="card-img-top"
													src={toAbsoluteUrl("media/description/bungy.jpg")}
													alt=""
												/>
												<div className="card-body">
													<h3>
														<b>
															{this.props.selectedLanguage === "nepali"
																? "बन्जीजम्प"
																: "Bungy Jump"}
														</b>
													</h3>
													<p className="card-text text-left">
														{this.props.selectedLanguage === "nepali"
															? "द लास्ट रिसोर्ट  भोटेकोशी गाउँपालिका वडा नम्बर १ मा पर्ने नयाँपुल भन्ने ठाउँ जहाँ बाह्रबिसे बजार बाट आधा घण्टा  समयको सवारी यात्राबाट पुग्न सकिने एक रमणीय स्थल हो | बन्जीजम्प  पातलो  रसिमा झुन्डेर हावामा स्वतन्त्र रुपले हाम्फाल्ने/ झुल्ने  एक  साहसिक आनन्द लिने खेल हो ।यस रिसोर्टमा  सफारी टेन्टहरूका साथै  सुन्दर बगैंचामा  शान्तिपूर्ण बसाइको आनद लिन सकिन्छ। यो विशेष रूपमा 4 घेरा सुरक्षाका साथ बन्जी जम्पिङको लागि डिजाइन गरिएको छ र स्विस मापन अनुसार 41,500 किलोग्राम वा 4.5 टन लोड भर्ने क्षमता रहेको  यस पुल भोटेकोशी नदीको १६० मिटर माथी  उचाईमा रहेको छ।"
															: "The Last Resort is a beautiful place called Nayapul in Bhotekoshi Gaonpalika Ward No. 1, which is a half hour drive from Barhabise Bazaar. Bungee jumping is an adventurous sport of jumping freely in the air by hanging on a thin rope. The resort offers safari tents as well as a peaceful stay in a beautiful garden. It is specially designed for bungee jumping with 4 round safety and has a load carrying capacity of 41,500 kg or 4.5 tons according to Swiss measurements."}
													</p>
												</div>
											</div>
											<div className="card" id="card">
												<img
													className="card-img-top"
													src={toAbsoluteUrl(
														"media/description/miteri_pool.jpg"
													)}
													alt=""
												/>
												<div className="card-body">
													<h3>
														<b>
															{this.props.selectedLanguage === "nepali"
																? "नेपाल चीन मितेरी पुल"
																: "Nepal China Miteri Bridge"}
														</b>
													</h3>
													{/* <p className="card-text text-left">
														{this.props.selectedLanguage === "nepali"
															? "तातोपानी गाउँ, सिन्धुपाल्चोक, बागमती प्रदेश ,  नेपालको उत्तरी सिमाना चीनसँग, काठमाडौंबाट ११४ किमी उत्तर पूर्वमा अवस्थित छ। लाङटाङको तातोपानी र रसुवा चीनसँगको नेपालको दुई मुख्य नाका हुन्। नेपाल निर्यात र आयात हुने समानहरुको चेक जांच सहित भन्सारको नियमित कार्य यहाँबाट हुने गरेको छ |"
															: "Tatopani village, Sindhupalchowk, Bagmati province, Nepal's northern border with China, is located 114 km northeast of Kathmandu. Tatopani and Rasuwa of Langtang are the two main ports of Nepal with China. Regular customs operations are carried out from here, including check check of goods exported and imported from Nepal"}
													</p> */}
												</div>
											</div>
											<div className="card" id="card">
												<img
													className="card-img-top"
													src={toAbsoluteUrl(
														"media/description/tatopanibhansar.jpg"
													)}
													alt=""
												/>
												<div className="card-body">
													<h3>
														<b>
															{this.props.selectedLanguage === "nepali"
																? "सुख्खा बन्दरगाह तातोपानी भन्सार"
																: "Dry port hot water customs"}
														</b>
													</h3>
													<p className="card-text text-left">
														{this.props.selectedLanguage === "nepali"
															? "तातोपानी गाउँ, सिन्धुपाल्चोक, बागमती प्रदेश ,  नेपालको उत्तरी सिमाना चीनसँग, काठमाडौंबाट ११४ किमी उत्तर पूर्वमा अवस्थित छ। लाङटाङको तातोपानी र रसुवा चीनसँगको नेपालको दुई मुख्य नाका हुन्। नेपाल निर्यात र आयात हुने समानहरुको चेक जांच सहित भन्सारको नियमित कार्य यहाँबाट हुने गरेको छ |"
															: "Tatopani village, Sindhupalchowk, Bagmati province, Nepal's northern border with China, is located 114 km northeast of Kathmandu. Tatopani and Rasuwa of Langtang are the two main ports of Nepal with China. Regular customs operations are carried out from here, including check check of goods exported and imported from Nepal"}
													</p>
												</div>
											</div>
											<div className="card" id="card">
												<img
													className="card-img-top"
													src={toAbsoluteUrl(
														"media/description/dhugunagadhi.jpg"
													)}
													alt=""
												/>
												<div className="card-body">
													<h3>
														<b>
															{this.props.selectedLanguage === "nepali"
																? "दुगुना गढी"
																: "Double fortress"}
														</b>
													</h3>
													<p className="card-text text-left">
														{this.props.selectedLanguage === "nepali"
															? "भोटेकोशी गाउँपालिका वडा नम्बर ३ मा पर्ने दुगुना गढीलाई देशको दश महत्त्वपूर्ण किल्ला मध्ये एक मानिन्छ |  इतिहासकारका अनुसार  तत्कालीन प्रधानमन्त्री जङ्गबहादुर राणाले सन् १८५५-१८५६ मा तिब्बतको आक्रमणबाट सहरको रक्षा गर्न निर्माण गरेको उल्लेख गरिएको छ ।"
															: "Duguna Gadhi in Bhotekoshi Gaonpalika Ward No. 3 is considered as one of the ten most important forts in the country According to historians, it was built by the then Prime Minister Jung Bahadur Rana in 1855-1856 to protect the city from the invasion of Tibet."}
													</p>
												</div>
											</div>
											{/* <div className="card" id="card">
												<img
													className="card-img-top"
													src="https://images.unsplash.com/photo-1656414563496-34686606f2ce?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
													alt=""
												/>
												<div className="card-body">
													<p className="card-text text-left">
														Some example text some example text. John Doe is an
														architect and engineer
													</p>
												</div>
											</div> */}
										</div>
									</div>
								</div>
							</div>
						</Card.Text>
					</Card.Body>
				</Card>
				<CardGroup id="card-group">
					<Card className="col-lg-6 d-flex">
						<Card.Body id="card-body">
							<Card.Title id="card-title">
								<div className="d-flex pb-2" id="map-icon">
									<SVG
										className="primary-icon"
										src={toAbsoluteUrl("media/hamropalika/svg/map_marker.svg")}
										alt=""
									/>
									<h2 className="font-weight-black pl-3 pt-6 homepage-heading">
										{this.props.selectedLanguage == "nepali"
											? "गाउँपालिका अबस्थित नक्शा"
											: "Boundaries"}
									</h2>
								</div>
							</Card.Title>
							<Card.Text>
								<img
									// style={{ height: "50px", width: "100%" }}
									className="w-10"
									style={{maxWidth: "350px"}}
									src={toAbsoluteUrl("/media/hamropalika/bhotekoshiStatic.png")}
									alt=""
								/>
							</Card.Text>
						</Card.Body>
					</Card>
					<Card className="col-lg-6 pb-5 d-flex">
						<Card.Body id="card-body">
							<Card.Title>
								<div className="d-flex pb-2 " id="map-icon" >
									<SVG
										className="primary-icon"
										src={toAbsoluteUrl("media/hamropalika/svg/map_marker.svg")}
										alt=""
									/>
									<h2 className="font-weight-black pl-3 pt-6 homepage-heading">
										{this.props.selectedLanguage == "nepali"
											? "सिमाना"
											: "Boundaries"}
									</h2>
								</div>
							</Card.Title>
							<Card.Text>
								<div className="row">
									{this.state.boundData.map((data, index) => {
										return (
											<div className={`pb-2 ${data.class}`} key={index}>
												<div className="row">
													<div className="col-4">
														<h5 className="pr-2 text-left simana-data">
															{this.props.selectedLanguage == "nepali"
																? data.key
																: data.keyEnglish}
															:
														</h5>
													</div>
													<div className="col-8">
														<h5 className="text-primary text-left">
															{this.props.selectedLanguage == "nepali"
																? data.value
																: data.valueEnglish}
														</h5>
													</div>
												</div>
											</div>
										);
									})}
								</div>
							</Card.Text>
						</Card.Body>
					</Card>
					{/* {this.getMunicpalId()} */}
					{/* {this.getMunicipalBounds()} */}
				</CardGroup>
			</>
		);
	}
}

const mapStateToProps = (state) => ({
	selectedLanguage: state.ward.selectedLanguage,
});
export default connect(mapStateToProps)(MunicipalityDescription);
